import React from "react";

import RCIQ_LOGO_DARK from "@/assets/logo/rciq-dark.png";
import RCIQ_LOGO_WHITE from "@/assets/logo/rciq-white.png";

/**
 * BrandLogo — official Revenue Cycle IQ AI lockup.
 *
 * Logos are bundled as local assets (imported above) so they ship with every
 * build and never depend on third-party CDN availability or hospital/corporate
 * network firewalls that may block external image domains.
 *
 * Brand rule:
 *   - Light/white backgrounds  → DARK logo  (theme="light", default)
 *   - Blue/dark backgrounds    → WHITE logo (theme="dark")
 *
 * variant: "header" | "hero" | "mark-only"
 */
export const BrandLogo = ({ variant = "header", theme = "light", className = "" }) => {
  const src = theme === "dark" ? RCIQ_LOGO_WHITE : RCIQ_LOGO_DARK;

  if (variant === "hero") {
    return (
      <div className={`flex items-center min-w-0 ${className}`} data-testid="brand-logo">
        <img
          src={src}
          alt="Revenue Cycle IQ AI — Insights That Drive Revenue"
          className="h-24 sm:h-28 lg:h-32 w-auto max-w-full object-contain select-none"
          draggable={false}
        />
      </div>
    );
  }

  if (variant === "mark-only") {
    return (
      <div className={`flex items-center justify-center flex-shrink-0 ${className}`} data-testid="brand-logo">
        <img
          src={src}
          alt="Revenue Cycle IQ AI"
          className="h-10 w-10 object-contain rounded-md select-none"
          draggable={false}
        />
      </div>
    );
  }

  return (
    <div className={`flex items-center flex-shrink-0 ${className}`} data-testid="brand-logo">
      <img
        src={src}
        alt="Revenue Cycle IQ AI — Insights That Drive Revenue"
        className="h-12 sm:h-14 w-auto object-contain select-none"
        draggable={false}
      />
    </div>
  );
};

export default BrandLogo;
